export default "__VITE_ASSET__CGEdju_e__"